import React from 'react';
import "./Home.css";
import Product from './Product';

function Home() {
    return (
        <div className="home">
            <div className="home_container">
                <img 
                    className="home_image"
                    src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Events/2020/PrimeDay/Fuji_TallHero_NonPrime_v2_en_US_1x._CB403670067_.jpg"
                    alt="amazon events"
                />

                <div className="home_row">
                    <Product 
                        id={10}
                        title="TCL 32-Inch TV"
                        price={14999}
                        image="https://m.media-amazon.com/images/I/71Ut6ZxFbpL._AC_UY218_.jpg"
                        rating={4}
                    />
                    <Product
                        id={11}
                        title="Samsung Smart Tv"
                        price={55699}
                        image="https://images-na.ssl-images-amazon.com/images/I/51NKhnjhpGL._AC_SL1024_.jpg"
                        rating={5}
                     />
                    <Product 
                        id={13}
                        title="Hisense Roku Tv"
                        price={79500}
                        image="https://images-na.ssl-images-amazon.com/images/I/71wq7qNoBLL._AC_SL1500_.jpg"
                        rating={3}
                    />
                </div>

                <div className="home_row">
                    <Product
                        id={14}
                        title="Apple MacBook Pro"
                        price={44800}
                        image="https://images-na.ssl-images-amazon.com/images/I/71qVOM%2BlgnL._AC_SL1500_.jpg"
                        rating={5}
                    />
                    <Product 
                        id={15}
                        title="Acer Aspire 5 Slim Laptop"
                        price={36499}
                        image="https://images-na.ssl-images-amazon.com/images/I/71vvXGmdKWL._AC_SL1500_.jpg"
                        rating={4}
                    />
                    
                </div>

                <div className="home_row">
                    <Product 
                        id={16}
                        title="Tablet 10 Inch Android 9.0 3G"
                        price={10999}
                        image="https://images-na.ssl-images-amazon.com/images/I/61NfcHUmxBL._AC_SL1000_.jpg"
                        rating={5}
                    />
                    <Product 
                        id={17}
                        title='Lenovo Tab M8 Tablet, 8" HD'
                        price={8999}
                        image="https://images-na.ssl-images-amazon.com/images/I/71nwV9yascL._AC_SL1500_.jpg"
                        rating={3}
                    />
                    <Product 
                        id={18}
                        title="Aple smart keyboard"
                        price={1499}
                        image="https://images-na.ssl-images-amazon.com/images/I/71mava1GE1L._AC_SL1500_.jpg"
                        rating={2}
                    />
                    <Product 
                        id={19}
                        title='Samsung Galaxy Tab A7 10.4"'
                        price={24599}
                        image="https://images-na.ssl-images-amazon.com/images/I/51JlOJeLp5L._AC_SL1000_.jpg"
                        rating={5}
                    />
                </div>
            </div>
        </div>
    )
}

export default Home
